import defs from '../_core/defs.js';
import apply from '../_helpers/apply.js';
// triggers one event
export default function triggerOne(object, name, triggerArgs) {
  var def = defs.get(object);
  var events = def == null ? void 0 : def.events[name];
  if (events) {
    var l = events.length;
    var i = 0;
    // allow to pass both array of args and single arg as triggerArgs
    if (Array.isArray(triggerArgs)) {
      while (i < l) {
        var event = events[i];
        triggerOne.latestEvent = event;
        var callback = event.callback,
          ctx = event.ctx;
        apply(callback, ctx, triggerArgs);
        i += 1;
      }
    } else {
      while (i < l) {
        var _event = events[i];
        triggerOne.latestEvent = _event;
        var _callback = _event.callback,
          _ctx = _event.ctx;
        _callback.call(_ctx, triggerArgs);
        i += 1;
      }
    }
  }
}
// latestEvent is used as required hack in somemethods
triggerOne.latestEvent = {
  info: {},
  name: null
};